import { Button } from '@atoms';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { ImageEvidence } from './styles';
import { Box } from '@mui/system';

interface IPreviewImageModalProps {
  open: boolean;
  handleClose: () => void;
  url: string;
  handleUpload: () => void;
  loading: boolean;
}
const PreviewImageModal = ({
  open,
  handleClose,
  url,
  handleUpload,
  loading,
}: IPreviewImageModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '10px',
          minWidth: '596px',
          height: '587px',
          position: 'relative',
        },
      }}
    >
      <DialogTitle>Preview Evidence Image</DialogTitle>
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            bgcolor: 'rgba(255,255,255,0.7)',
            zIndex: 1301,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={40} />
        </Box>
      )}
      <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <ImageEvidence src={url} alt="image-evidence" />
      </DialogContent>
      <DialogActions>
        <Button sx={{ paddingX: '30px' }} variant="contained" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          sx={{ paddingX: '30px' }}
          variant="contained"
          color="primary"
          onClick={handleUpload}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewImageModal;
